export const isDev = ['dev', 'development'].includes(
  process.env.NODE_ENV ?? 'dev'
);
export const isProd = process.env.APP_ENV === 'production';

export default null;
